<div class="settled-exchanges-container container-fluid">
  <router-outlet></router-outlet>
</div>
